import styles from "./PleaseWait.module.css";


//#region [Props]
type PleaseWaitProps = {
    text?: string;
};
//#endregion

//#region [Component]
export default function PleaseWait({ text = "Henter innhold..." }: PleaseWaitProps) {
    return <div className={styles.SLoaderContainer}>
        <div className={styles.Spinner} />
        <p>{text}</p>
    </div>
}
//#endregion